var App = App || {};

App.Base = (function ($) {
    'use strict';

    var $window = $(window),
        $html = $('html'),
        $body = $('body');


    function init() {
        HashSupport();
        ZagParallaxExample();
        ZagScrollAnimateExample();
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }

        $('a[href^="#"]')
            .not('.skipto, #sbModalSubmit')
            .on('click', function (e) {
                var $this = $(this);

                e.preventDefault();

                if ($this.attr('href') !== '#' && $this.attr('role') !== 'tab') {
                    scrollTo($($this.attr('href')));
                }
            });
    }

    function addOverlay() {
        $body.addClass('has-overlay');
    }

    function removeOverlay() {
        $body.removeClass('has-overlay');
    }

    function ZagParallaxExample() {
        $(".page-masthead .page-masthead-image").ZagParallax({ divisor: 2 });
    }


    onScrollInit($('.os-animation'));

    $('.staggered-animation').each(function () {
        var $this = $(this);
        onScrollInit($this, $this.parents('.staggered-animation-container'));
    });

    function onScrollInit(items, $trigger) {
        items.each(function () {
            var $osElement = $(this),
                osAnimationClass = $osElement.attr('data-os-animation'),
                osAnimationDelay = $osElement.attr('data-os-animation-delay');

            $osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var $osTrigger = ($trigger) ? $trigger : $osElement;

            $osTrigger.waypoint(function () {
                $osElement
                    .one('animationend', function () {
                        $osElement
                            .addClass('animation-complete')
                            .removeClass('animate__animated');
                    })
                    .addClass('animate__animated')
                    .addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }


    function ZagScrollAnimateExample() {

        $(".page-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".page-masthead-title", type: "animate__fadeInRight", stagger: 0 },
                { selector: ".page-masthead-rich-text", type: "animate__fadeInRight", stagger: 0 },
                { selector: ".page-masthead-ctas > ul > li", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    $('iframe.responsive').each(function () {
        $(this).iFrameResize();
    });

    $(".accordion-collapse").on("show.bs.collapse", function () {
        if (!$(this).closest(".accordion-item").hasClass("show")) {
            $(this).closest(".accordion-item").addClass("show")
        }
    });


    $(".accordion-collapse").on("hide.bs.collapse", function () {
        if ($(this).closest(".accordion-item").hasClass("show")) {
            $(this).closest(".accordion-item").removeClass("show")
        }
      
    });

    return {
        init: init,
        $window: $window,
        $html: $html,
        $body: $body,
        addOverlay: addOverlay,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});